// extracted by mini-css-extract-plugin
export default {"tooltipContainer":"styles_tooltipContainer__LfO9+","label":"styles_label__RBdo7","tooltip":"styles_tooltip__XndPp"};